import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { z } from "zod";

import { Spinner } from "../../components";
import { getUsersList, reassignUser } from "../../../config/redux/actions/admin";
import { formatErrorMessage } from "../../../helpers/helpers";
import { ROLE_LIST } from "../../../constants";
import { setSelectedUser } from "../../../config/redux/slice/adminSlice";

const schema = z.object({
    role_id: z.number().min(0)
});

const UpdateUserRole = () => {
    const dispatch = useDispatch();

    const { isLoading, errorMessage, selectedUser } = useSelector((state) => state.admin);
    const { formState, register, handleSubmit } = useForm({ resolver: zodResolver(schema), mode: 'all' });

    const onSubmit = async ({ role_id }) => {
        const apiData = { role_id, user_id: selectedUser.USER_ID };
        
        try {
            const result = await dispatch(reassignUser(apiData)).unwrap();
            
            dispatch(setSelectedUser(null));
            toast.success(result.message);
            
            await dispatch(getUsersList())
        } catch (error) {
            toast.error(formatErrorMessage(error));
        }
    };

    return ( 
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group">
                <label htmlFor="role">Reassign {selectedUser.FIRST_NAME} {selectedUser.LAST_NAME} (Currently {selectedUser.USER_ROLE_TEXT})</label>
            
                <select id="role" className="form-control input-lg" {...register("role_id", { valueAsNumber: true })}>
                    <option value="">Select a role</option>
                    {ROLE_LIST
                        .filter((role) => role.id !== parseInt(selectedUser.USER_ROLE_ID))
                        .map((role) => <option key={role.id} value={role.id}>{role.name}</option>)}
                </select>

                {formState.errors.role && <div className="alert alert-danger" role="alert">{formState.errors.role.message}</div>}
            </div>

            {errorMessage && (
                <div className="mb-4 w-100">
                    <div className="alert alert-danger" role="alert">
                        {errorMessage}
                    </div>
                </div>
            )}

            {isLoading ? <Spinner /> : <button type="submit" className="btn btn-danger" disabled={!formState.isValid}>Save Changes</button>}
        </form>
    );
};

 
export default UpdateUserRole;